<template>
  <modal
    class="typography-service-modal"
    bodyClasses="mt-2"
    :show.sync="showModal"
    @close="closeModal"
    headerClasses="pb-0"
    :showClose="true"
  >
    <h6 slot="header" class="modal-title" id="modal-title-default">
      Add Professional Design Service?
    </h6>
    <p>
      Enhance your creative project with our expert design solutions, tailored
      to integrate your branding elements and title onto licensed artwork
      seamlessly. Our team of skilled designers will ensure a captivating,
      professional, and marketable presentation.
    </p>
    <small class="mb-2 d-block">Examples</small>
    <div class="d-flex example-wrapper">
      <!-- <div
        v-for="image of exampleImages1"
        v-bind:key="image"
        class="example-img"
        @click="lightboxImage = image"
      >
        <img :src="image" />
      </div> -->
      <div
        v-for="image of exampleImages1"
        v-bind:key="image"
        class="example-img"
      >
        <img :src="image" />
      </div>
    </div>
    <div class="d-flex example-wrapper mb-3">
      <div
        v-for="image of exampleImages2"
        v-bind:key="image"
        class="example-img"
        @click="lightboxImage = image"
      >
        <img :src="image" />
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <div>
        <small class="mb-2 d-block">Select an option</small>
        <base-radio
          v-for="option in options"
          v-bind:key="option.id"
          :name="option.name"
          class="mb-3"
          v-model="selected"
          @input="handleChange"
        >
          <strong>{{ option.name }} ${{ option.value }}</strong>
          <small class="d-block">{{ option.description }}</small>
        </base-radio>
      </div>
    </div>

    <base-button
      type="primary"
      :disabled="!selected"
      @click="handleAdd"
      class="mt-4 add-service-button"
      block
      >ADD SERVICE FOR THIS ARTWORK</base-button
    >
    <div class="text-center">
      <base-button type="link" class="no-thanks-link" @click="closeModal"
        >NO THANKS</base-button
      >
    </div>
    <!-- <div v-if="lightboxImage" class="example-lightbox">
      <img :src="lightboxImage" @click="lightboxImage = ''" />
      <div
        class="lightbox-button-wrapper d-flex justify-content-between align-items-center w-100"
      >
        <button class="lightbox-button" @click="prevImage">&laquo;PREV</button>
        <p class="d-none d-md-block" @click="lightboxImage = ''">
          CLICK TO CLOSE
        </p>
        <p class="d-block d-md-none" @click="lightboxImage = ''">
          TAP TO CLOSE
        </p>
        <button class="lightbox-button" @click="nextImage">NEXT&raquo;</button>
      </div>
    </div> -->
  </modal>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "typography-service-modal",
  data() {
    return {
      selected: "",
      lightboxImage: "",
      exampleImages1: [
        "/img/design-service/design-example-1.jpg",
        "/img/design-service/design-example-2.jpg",
        "/img/design-service/design-example-3.jpg",
        "/img/design-service/design-example-4.jpg",
      ],
      exampleImages2: [
        "/img/design-service/design-example-5.jpg",
        "/img/design-service/design-example-6.jpg",
        "/img/design-service/design-example-7.jpg",
        "/img/design-service/design-example-8.jpg",
      ],
    };
  },
  methods: {
    scrollToElement: function () {
      if (document.querySelector(".add-service-button")) {
        document.querySelector(".add-service-button").scrollIntoView({
          behavior: "smooth",
        });
      }
    },
    prevImage() {
      const images = [...this.exampleImages1, ...this.exampleImages2];
      const currIdx = images.findIndex((i) => i === this.lightboxImage);

      if (currIdx >= 0) {
        if (currIdx === 0) {
          this.lightboxImage = images[images.length - 1];
        } else {
          this.lightboxImage = images[currIdx - 1];
        }
      }
    },
    nextImage() {
      const images = [...this.exampleImages1, ...this.exampleImages2];
      const currIdx = images.findIndex((i) => i === this.lightboxImage);

      if (currIdx >= 0) {
        if (currIdx === images.length - 1) {
          this.lightboxImage = images[0];
        } else {
          this.lightboxImage = images[currIdx + 1];
        }
      }
    },
    handleChange() {
      this.scrollToElement("add-service-button");
    },
    handleAdd() {
      this.$emit("serviceSelected", this.selected);
      this.closeModal();
    },
    closeModal() {
      // Close modal
      this.selected = "";
      this.$store.commit("setLastAddedToCart", null);
      this.$store.commit("showDesignServiceModal", false);
    },
  },
  props: {
    options: {
      type: Array,
    },
  },
  computed: {
    ...mapState["isLoggedIn"],
    showModal: {
      get() {
        return this.$store.state.showDesignServiceModal;
      },
      set(value) {
        this.$store.commit("showDesignServiceModal", value);
      },
    },
  },
};
</script>

<style lang="scss">
.typography-service-modal {
  .example-lightbox {
    padding: 10px;
    background-color: rgba(0, 0, 0, 0.85);
    position: fixed;
    z-index: 10000;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    p {
      color: white;
      margin-top: 20px;
      font-size: 0.75rem;
      user-select: none;
      font-weight: bold;
      cursor: pointer;
    }

    img {
      max-width: 100%;
      max-height: 80%;
      cursor: pointer;
    }

    .no-thanks-link {
      &:active,
      &:focus,
      &:hover {
        box-shadow: none;
      }
    }

    .lightbox-button {
      padding: 4px 8px;
      background: none;
      border: none;
      font-size: 0.75rem;
      color: white;

      &:focus,
      :active {
        outline: none;
      }
    }

    .lightbox-button-wrapper {
      max-width: 400px;
    }
  }

  .example-wrapper {
    .example-img {
      // cursor: pointer;
      img {
        object-fit: cover;
        max-width: 100%;
      }
    }
  }
  .custom-control-label {
    height: auto !important;
  }
}
</style>
